import React, { useEffect, useState } from 'react';
import { Button, Container, Grid, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useCookies } from 'react-cookie';

import background from 'src/assets/cover/splash-screen/background.png';
import header from 'src/assets/cover/splash-screen/header.png';
import tree from 'src/assets/cover/splash-screen/tree.png';
import logo from 'src/assets/cover/splash-screen/logo.png';
import { SignalCellularNullRounded } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  grid: {
    minHeight: '100vh',
    width: '100%',
    backgroundImage: `url(${background})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
    // overflowY: 'scroll'
  },
  leftSide: {
    minHeight: '100vh',
    width: '100%',
    backgroundColor: '#30664D',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2rem',
    textAlign: 'center'
  },
  rightSide: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  imageBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

const SplashScreen = ({ dismissSplashScreen }) => {
  const classes = useStyles();
  const [text, setText] = useState();

  const [cookies, setCookie] = useCookies(['name']);

  const french = {
    title:
      'Maohi Games transforme votre plaisir en impact positif avec SeedOut Fenua',
    description:
      'Le site internet SeedOut Fenua est en cours de reconstruction !',
    button: 'Consulter l’ancien site internet'
  };
  const english = {
    title: 'Maohi Games connect your fun to the well-being of the planet',
    description: 'SeedOut Fenua website is being rebuilt!',
    button: 'Visit the old website'
  };

  useEffect(() => {
    const language = navigator.language.split('-');
    switch (language[0]) {
      case 'fr':
        setText(french);
        break;
      default:
        setText(english);
        break;
    }
  }, []);

  return (
    <Grid
      alignItems="center"
      className={classes.grid}
      container
      direction="row"
      justify="center">
      <Grid className={classes.leftSide} item md={4} xs={12}>
        <img
          alt=""
          src={logo}
          style={{ marginTop: '4rem 0', height: '8rem' }}
        />
        <Typography
          style={{ marginBottom: '4rem', marginTop: '2rem', color: 'white' }}>
          {text?.title}
        </Typography>
        <hr
          style={{
            marginBottom: '4rem',
            marginTop: '1rem',
            backgroundColor: 'white',
            width: '100%',
            border: '1px solid white'
          }}
        />
        <Typography style={{ color: 'white', fontSize: '2rem' }}>
          {text?.description}
        </Typography>
        <img alt="" src={tree} style={{ margin: '4rem 0', height: '10rem' }} />

        <Button
          children={text?.button}
          onClick={() => dismissSplashScreen()}
          style={{
            backgroundColor: 'white',
            color: 'black',
            fontWeight: 'bold'
          }}
          variant="contained"
        />
      </Grid>

      <Grid className={classes.rightSide} item md={8} xs={0}>
        <Container className={classes.imageBox}>
          <img alt="" src={header} />
        </Container>
      </Grid>
    </Grid>
  );
};

export default SplashScreen;
